<template>
  <div class="tip-bar" :class="type">
    <Icon v-if="icon !== false" :type="iconType" class="tip-icon" />
    <div class="tip-body"><slot /></div>
  </div>
</template>

<script>
// 通用提示条(收敛系统/钱包/活动各页散落的绿/黄硬编码提示框)
// type: success(绿) | warning(黄)。icon=false 可去掉前置图标。
export default {
  name: 'TipBar',
  props: {
    type: { type: String, default: 'warning', validator: (v) => ['success', 'warning'].includes(v) },
    icon: { type: [String, Boolean], default: true }
  },
  computed: {
    iconType() {
      if (typeof this.icon === 'string') return this.icon
      return this.type === 'success' ? 'ios-checkmark-circle-outline' : 'ios-alert-outline'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.tip-bar {
  display: flex; align-items: flex-start; gap: 6px;
  padding: 10px 14px; font-size: 13px; line-height: 1.5;
  border: 1px solid transparent; border-radius: @radius;
}
.tip-bar.success { background: @tip-success-bg; border-color: @tip-success-bd; color: @tip-success-tx; }
.tip-bar.warning { background: @tip-warn-bg; border-color: @tip-warn-bd; color: @tip-warn-tx; }
.tip-icon { font-size: 16px; flex-shrink: 0; margin-top: 1px; }
.tip-body { flex: 1; min-width: 0; }
</style>
